const SET_WALL_META_DATA = 'META_DATA/SET_WALL_META_DATA';
const SET_WALLS_META_DATA = 'META_DATA/SET_WALLS_META_DATA';

export { SET_WALL_META_DATA, SET_WALLS_META_DATA };
